import { render, staticRenderFns } from "./GetTO.vue?vue&type=template&id=17b47d4c&scoped=true"
import script from "./GetTO.vue?vue&type=script&lang=js"
export * from "./GetTO.vue?vue&type=script&lang=js"
import style0 from "./GetTO.vue?vue&type=style&index=0&id=17b47d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b47d4c",
  null
  
)

export default component.exports